import type { CarouselPublishPlatform } from './buildCarouselPublishInput';
import type { QuoteCarouselFormat } from './types';

/**
 * The Instagram Graph API only accepts carousel images whose aspect ratio is
 * between 4:5 and 1.91:1, so a 9:16 slide is rejected by Meta. TikTok photo
 * posts and Facebook Page photo posts accept both formats.
 */
export const INSTAGRAM_SAFE_FORMAT: QuoteCarouselFormat = 'portrait_4x5';

export function isFormatAllowedForPlatform(
  format: QuoteCarouselFormat,
  platform: CarouselPublishPlatform,
): boolean {
  if (platform === 'instagram') return format !== 'portrait_9x16';
  return true;
}
